import { render } from "./dwhs.vue?vue&type=template&id=309bf41a&scoped=true"
import script from "./dwhs.vue?vue&type=script&lang=js"
export * from "./dwhs.vue?vue&type=script&lang=js"

import "./dwhs.vue?vue&type=style&index=0&id=309bf41a&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-309bf41a"]])

export default __exports__